import { connect } from 'react-redux'
import { fetchBlazonsPageData } from 'shared/store/kingdom/blazons'
import { FormCouponComponent } from './FormCouponComponent'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import {
    addCoupon,
    resetAddCouponSuccess
} from 'shared/store/kingdom/privileges'
import type { CouponForm } from 'shared/types'

const mapStateToProps = (state: RootState) => {
    const { collectMode, ecommerceMode } = state.ecommerceOrderState
    return {
        ...state.kingdomPrivilegesPageState,
        pickUpType: collectMode || ecommerceMode
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    addCoupon: (form: CouponForm) => d(addCoupon(form)),
    fetchBlazonsPageData: () => d(fetchBlazonsPageData()),
    reset: () => d(resetAddCouponSuccess())
})
const FormCoupon = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormCouponComponent)

export { FormCoupon }
